import * as olSource from "ol/source";

function xyz({ url, attributions, ...props }) {
  return new olSource.XYZ({ url, attributions, ...props });
}

export default xyz;
